<template>
  <div class="details_apply">
    <div class="top_bg">
      <img v-if="detailsList.order.exa_status == '0'" src="../../assets/images/Apply/img_shz_.png" alt="" />
      <img v-if="detailsList.order.exa_status == '1'" src="../../assets/images/Apply/img_shtg.png" alt="" />
      <img v-if="detailsList.order.exa_status == '2'" src="../../assets/images/Apply/img_shwtg_.png" alt="" />
      <img v-if="detailsList.order.exa_status == '3'" src="../../assets/images/Apply/img_ysx_.png" alt="" />
      <img v-if="detailsList.order.exa_status == '4'" src="../../assets/images/Apply/img_qydwc.png" alt="" />
    </div>
    <div class="formdata_box">
      <div class="bx_item">
        <div class="fs-40">审核回复内容</div>
        <div class="box fs-28 rich-text" v-html="decodeHTML(detailsList.order.fail_exp)"></div>
      </div>
      <div class="bx_item">
        <div class="fs-40">服务说明</div>
        <div class="box fs-28 rich-text" v-html="decodeHTML(detailsList.insurance_type.instype_explain)"></div>
      </div>
      <!-- <div class="bx_item">
        <div class="fs-40">手机照片1</div>
        <div class="img_detail">
          <img :src="detailsList.order.tem_img" alt="" @click="$imagePreview([detailsList.order.tem_img])" />
        </div>
      </div> -->

      <div class="bx_item">
        <div class="fs-40 mt-50">用户信息</div>
        <div class="item_detail g-flex-jb g-flex-ac" v-for="item in columns" :key="item.id" v-show="!(
          item.label === '裸机价格' &&
          detailsList.insurance_type.instype_id === 3
        )
          ">
          <div class="left fs-28">{{ item.label }}</div>
          <div class="right fs-28 right-value" :class="item.label == '裸机价格' ? 'color_red' : ''">
            <span v-if="item.label == '裸机价格'">￥</span><span class="rich-text" v-html="item.value || '-'"></span>
          </div>
        </div>
      </div>
      <div class="img_core" v-if="detailsList.order.exa_status == 1">
        <div>
          <img src="@/assets/images/examplePic/erweima.jpg" alt="">

        </div>
        <div style="color: gray;margin-top: 10px;">服务履约请扫码进入移动小程序</div>
      </div>
      <my-button v-if="isCanBack" class="confirm-btn" type="primary" @click="goBack()">重新提交申请
      </my-button>
    </div>

  </div>
</template>

<script>
import { Toast } from "vant";
import { decodeHTML } from "@/common/filters";

export default {
  name: "detailsApply",
  data() {
    return {
      showText: false,
      detailsList: {
        insurance_type: {},
        order: {},
      },
      columns: [],
      isCanBack: false
    };
  },
  computed: {
    decodeHTML() {
      return (str) => {
        return decodeHTML(str);
      };
    },
  },
  created() {
    console.log('111', this.$route.query);
    const { id, fromIn } = this.$route.query

    this.$http.geYidOrderYidong({ order_id: id }).then((res) => {
      console.log('222', res);

      console.log('fromIn',fromIn);
      
      this.detailsList = res.data;
      console.log('this.detailsList.order.exa_status',this.detailsList.order.exa_status);

      // if (this.detailsList.order.exa_status == 2) {
      //   this.isCanBack = true
      // }
      this.columns = [
        { label: "手机号码", value: this.detailsList.order.phone },
        { label: "IMEI号或序列号", value: this.detailsList.order.imei },
        { label: "保卡卡密", value: this.detailsList.order.card_secret },
        { label: "手机品牌", value: this.detailsList.order.brandYd },
        { label: "手机型号", value: this.detailsList.order.modelYd },
        { label: "手机规格", value: this.detailsList.order.ramlYd },
      ];



    });
  },
  methods: {

    goBack() {
      let route = "";

      route = {
        path: "/RightApply/moveAddApply",
        query: { order_id: this.detailsList.order.order_id },
      };
      this.$router.push(route);

    }

  },
};
</script>

<style scoped lang="less">
.confirm-btn {
  width: calc(100vw - 150px);
  margin: 30px auto 0;
}

.details_apply {
  .top_bg {
    position: relative;
    width: 100vw;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .btn_edit {
    margin-bottom: 80px;
    width: 80vw;
    margin: 0 auto;
  }

  .btn_edit1 {
    margin-bottom: 80px;
    width: 92vw;
    margin: 0 auto;
  }

  .btn_edit3 {
    margin-bottom: 80px;

    .error_his_le {
      color: #577bb5;
      width: 280px;
      height: 40px;

      img {
        width: 38px;
        height: 38px;
      }
    }

    .error_his_ri {
      color: #577bb5;
      height: 40px;
    }
  }

  .formdata_box {
    position: absolute;
    top: 140px;
    background: white;
    width: 100vw;
    padding: 20px 0 50px 0;
    border-radius: 40px 40px 0px 0px;

    .bx_item {
      width: calc(100vw - 60px);
      margin: 40px auto;

      .box {
        line-height: 44px;
        margin-top: 20px;
        padding: 28px 25px;
        background: #f6f8fe;
        border-radius: 16px;
        color: #333333;
        font-family: PingFang SC;
        font-weight: 400;
      }

      .item_order {
        min-height: 370px;
        background: #f6f8fe;
        border-radius: 16px;
        padding-bottom: 20px;
      }

      .item_detail {
        min-height: 120px;
        line-height: 120px;
        padding: 20px 0;
        opacity: 0.98;
        border-bottom: 1px solid #eeeeee;

        .color_red {
          span {
            color: #e86161;
          }
        }
      }

      .color_b {
        margin-left: -10px;
        color: #577bb5;
      }

      .left {
        width: 240px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
      }

      .right {
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
      }
    }

    .img_detail {
      margin: 20px auto 0 auto;
      width: calc(100vw - 60px);
      height: 345px;
      border-radius: 16px;

      img {
        width: calc(100vw - 60px);
        height: 345px;
        object-fit: cover;
        border-radius: 20px;
      }
    }

    .img_core {

      width: 100%;
      height: 345px;

      div {
        display: flex;
        justify-content: center;
      }

      img {
        width: calc(50vw - 60px);
        height: 300px;
        object-fit: cover;
      }
    }

    .video {
      width: calc(100vw - 60px);
      height: 345px;
    }
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 90vw;
  min-height: 30vh;
  max-height: 90vh;
  overflow-y: auto;
  background-color: #f6f8fe;
  border-radius: 20px;

  .wra_tittle {
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #323234;
    line-height: 60px;
    width: 90vw;
    margin: 20px auto;
    text-align: center;
  }

  div:nth-child(2) {
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    max-height: 70vh;
    overflow-y: scroll;
    width: 80vw;
    margin: 0 auto;
    color: #333333;
    line-height: 44px;
  }

  .wra_btn {
    width: 400px;
    height: 80px;
    background: #577bb5;
    box-shadow: 0px 6px 15px 1px rgba(87, 123, 181, 0.3);
    border-radius: 40px;
    text-align: center;
    color: white;
    line-height: 80px;
    margin: 30px auto;
  }
}

.right-value {
  max-width: 500px;
}

::v-deep .rich-text img {
  max-width: 100%;
}
</style>
